<template>
  <div>
    <quotationTable
      :tabShow="'pending'"
      :unfixedTableThead="unfixedTableThead"
      :tableData="tableData"
      :totalNum="totalNum"
      @handleClick="handleClick"
      @child-event="getLists"
    ></quotationTable>
  </div>
</template>

<script>
import quotationTable from "../../components/quotationTable.vue";
// import { queryQuotationSeekPageForSupplier } from "@/app/inquiry/api/all";
import { queryWaitEcQuote } from "@/app/inquiry/api/all";

export default {
  components: {
    quotationTable
  },
  data() {
    return {
      tableData: [],
      totalNum: 0,
      unfixedTableThead: [
        {
          label: "采购单编号",
          prop: "seekCode",
          width: "120",
          checked: true,
          align: "left",
          fixed: "left"
        },
        {
          label: "采购标题",
          prop: "seekTitle",
          width: "253",
          checked: true,
          align: "left",
          fixed: "left"
        },
        {
          label: "采购单位",
          prop: "purchaseOrgName",
          width: "210",
          checked: true,
          align: "left"
        },
        {
          label: "供应商",
          prop: "supplierName",
          width: "210",
          checked: true,
          align: "left"
        },
        {
          label: "采购总金额(元)",
          prop: "referenceAmount",
          width: "100",
          checked: true,
          align: "right",
          type: "num"
        },
        {
          label: "报价截止时间",
          prop: "seekOffTime",
          width: "150",
          checked: true,
          align: "left"
        }
      ]
    };
  },
  methods: {
    handleClick(row, value) {
      sessionStorage.setItem(
        "inquiryPathData",
        JSON.stringify({
          path: "pending",
          label: "待报价"
        })
      );
      if (value === 1) {
        this.$router.push(
          {
            path: "/inquiry/inquiryDetail/detail",
            query: {
              seekId: row.seekId,
              seekSupplierId: row.seekSupplierId,
              supplierId: row.supplierId
            }
          }
          // `/inquiry/inquiryDetail/detail/${row.seekId}/${row.seekSupplierId}`
        );
      } else if (value === 2) {
        this.$router.push(
          {
            path: "/inquiry/inquiryDetail/detail",
            query: {
              seekId: row.seekId,
              seekSupplierId: row.seekSupplierId,
              supplierId: row.supplierId
            }
          }
          // `/inquiry/inquiryDetail/detail/${row.seekId}/${row.seekSupplierId}`
        );
      }
    },
    getLists(data) {
      let openId = JSON.parse(localStorage.getItem("userInfo")).openId || 0;
      queryWaitEcQuote({
        ...data,
        quoteType: 1,
        openId: openId,
        isShowPageLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          this.tableData = res.data.data.rows;
          this.totalNum = res.data.data.recordsTotal;
        }
      });
    }
  }
};
</script>
